import React from 'react';

import {
    Alignment,
    Switch
} from "@blueprintjs/core";

import './index.css';

const CustomSwitch = props => {
    return (
        <Switch className='custom-bp3-success-intent' alignIndicator={Alignment.RIGHT} {...props}/>
    );
}

export default CustomSwitch;